import { Component, OnInit } from '@angular/core';
import { AcquisitionTypeDto, CurrencyDto, GroupDto, LandParcelDto, LandTitleDto, MeasureDto, SubGroupDto, SubSubGroupDto, CofOStatusDto } from '@cradua/data';
import { Observable } from 'rxjs';
import { AcquisitionRoleHelperFunc } from '../../acquisition-role-func';
import { AcquisitionFacade } from '../../state/+acquisition/acquisition.facade';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { fadeInAnimation } from 'libs/shared/src/lib/_animations/fade-in.animation';

@Component({
  selector: 'cradua-land-title-report-container',
  templateUrl: './land-title-report-container.component.html',
  styleUrls: ['./land-title-report-container.component.scss'],
  animations: [fadeInAnimation],
})
export class LandTitleReportContainerComponent implements OnInit {

  isLoadingLandTitle$: Observable<any>;
  isLoadingAcquisitionType$: Observable<any>;
  isLoadingCurrency$: Observable<any>;
  isLoadingMeasure$: Observable<any>;
  isLoadingSubSubGroup$: Observable<any>;
  isLoadingSubGroup$: Observable<any>;
  isLoadingGroup$: Observable<any>;
  isLoadingCategory$: Observable<any>;
  isLoadingLandParcel$: Observable<any>;
  isLoadingCofOStatus$: Observable<any>;

  landTitle$: Observable<LandTitleDto[]>;
  acquisitionType$: Observable<AcquisitionTypeDto[]>;
  currency$: Observable<CurrencyDto[]>;
  measure$: Observable<MeasureDto[]>;
  subSubGroup$: Observable<SubSubGroupDto[]>;
  subGroup$: Observable<SubGroupDto[]>;
  group$: Observable<GroupDto[]>;
  category$: Observable<any[]>;
  landParcel$: Observable<LandParcelDto[]>;
  cofOStatus$: Observable<CofOStatusDto[]>;

  assignedRoles = JSON.parse(localStorage.getItem('AssignedRoles')) as any[] || [];
  activities = [];
  view = 'mainSearch';
  task = "list";
  constructor(
    private landTitleFacade: AcquisitionFacade,
    private gatewayFacade: GatewayFacade,
  ) {}

  ngOnInit(): void {
    this.activities = AcquisitionRoleHelperFunc(this.assignedRoles) || [];
    this.isLoadingAcquisitionType$ = this.gatewayFacade.isLoadingGateway("AcquisitionType");
    this.isLoadingCurrency$ = this.gatewayFacade.isLoadingGateway("Currency");
    this.isLoadingMeasure$ = this.gatewayFacade.isLoadingGateway("Measure");
    this.isLoadingSubSubGroup$ = this.gatewayFacade.isLoadingGateway("SubSubGroup");

    this.isLoadingGroup$ = this.gatewayFacade.isLoadingGateway("Group");
    this.isLoadingSubGroup$ = this.gatewayFacade.isLoadingGateway("SubGroup");
    this.isLoadingCategory$ = this.gatewayFacade.isLoadingGateway("Category");
    this.isLoadingCofOStatus$ = this.gatewayFacade.isLoadingGateway("CofOStatus");

    this.landTitle$ = this.landTitleFacade.loadRegister$;
    this.subGroup$ = this.gatewayFacade.loadGateway("SubGroup");
    this.group$ = this.gatewayFacade.loadGateway("Group");
    this.subSubGroup$ = this.gatewayFacade.loadGateway("SubSubGroup");
    this.category$ = this.gatewayFacade.loadGateway("Category");
    this.measure$ = this.gatewayFacade.loadGateway("Measure");
    this.currency$ = this.gatewayFacade.loadGateway("Currency");
    this.acquisitionType$ = this.gatewayFacade.loadGateway("AcquisitionType");
    this.cofOStatus$ = this.gatewayFacade.loadGateway("CofOStatus");
  }

  onSearch(value) {
    // const query = {name: value};
    console.log('land title ', value)
    this.isLoadingLandTitle$ = this.landTitleFacade.isLoadingAcquisition(value);
  }

  onTask(task: string) {
    console.log(task);
    this.task = task;
  }
}
